module.exports = __webpack_public_path__ + "static/img/reward-head.b3b4d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/reward-head.png
// module id = Y2AM
// module chunks = 216